import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const quizzesSlice = createSlice({
  name: "quizzes",
  initialState,
  reducers: {},
});

export const {} = quizzesSlice.actions;
export default quizzesSlice.reducer;
